import { combineReducers } from 'redux-immutable'
import projectNonServiceGetReducer from './project-non-service-get-reducer'
import projectNonServiceEditReducer from './project-non-service-edit-reducer'

export default combineReducers({
  projectNonServiceGet: projectNonServiceGetReducer,
  projectNonServiceEdit: projectNonServiceEditReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/project-code/index.js